import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=bf6c8ba8&scoped=true&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.styl?vue&type=style&index=0&id=bf6c8ba8&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6c8ba8",
  null
  
)

export default component.exports